import React from 'react';
import styles from './EmailConfirmationSend.module.css';
import { CustomButton, CustomInputText, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { sendConfirmationEmail } from '../../../services/authService';

const EmailConfirmationSend = () => {
    const {t} = useTranslation();

    const [email, setEmail] = React.useState<string>('');
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isSent, setIsSent] = React.useState<boolean>(false);

    const handleSendEmail = async () => {
        try {
            setIsLoading(true);

            await sendConfirmationEmail(email);

            setIsSent(true);
            setIsLoading(false);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    const isEmailFormatOk = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                { !isSent &&
                    <>
                        <CustomTitle className={styles.title}>{t('forgot_password.enter_email')}</CustomTitle>
                
                        { isLoading &&
                            <div className={styles.loader}>
                                <CustomLoader isLoading={isLoading} loaderType="circular" />
                            </div>
                        }

                        { !isLoading &&
                            <div className={styles.containerInputs}>
                                <CustomInputText id='email' textValue={email} setTextValue={setEmail} label={t('signin.email')} />
                                <CustomButton onClick={() => handleSendEmail()} disabled={!isEmailFormatOk()}>{t('general.confirm')}</CustomButton>
                            </div>
                        }
                    </>
                }

                { isSent &&
                    <CustomTitle className={styles.title}>{t('forgot_password.email_sent')}</CustomTitle>
                }
            </div>
        </div>
    );
}

export default EmailConfirmationSend;